import PostGrid from "@components/grid/PostGrid";
import { AttrProps, Image } from "@customTypes/index";
import useResponsiveCmsSettings from "@hooks/useResponsiveCmsSettings";
import { CmsBreakPointsDefaults } from "@lib/constants";
import { Button, Col, Layout, Row } from "antd";
import { useEffect, useState } from "react";

interface TaxonomyResults {
    id: number
    name: string
    slug: string
    hasNewPosts: boolean
    taxonomy: string
    description: string
    link: string
    count: number
    color: string
    image: Image
}

interface TaxonomyCollectionsProps {
    className?: string;
    attrs: AttrProps;
    results: TaxonomyResults[];
}

const defaultProps: TaxonomyCollectionsProps = {
    results: [],
    attrs: {
        breakpoints: {
            desktop: {
                total: CmsBreakPointsDefaults.DESKTOP.TOTAL
            },
            tablet: {
                total: CmsBreakPointsDefaults.TABLET.TOTAL
            },
            mobile: {
                total: CmsBreakPointsDefaults.MOBILE.TOTAL
            },
        }
    }
};

const TaxonomyCollections = ({ className, attrs, results }: TaxonomyCollectionsProps) => {
    const [isOpen, setOpen] = useState(false)
    const [taxData, setTaxData] = useState<any[]>([])
    const { total } = useResponsiveCmsSettings(attrs.breakpoints);

    useEffect(() => {
        if (results && total) {
            setTaxData(results?.reduce((temp: any, value, index) => {
                if (index < (!isOpen ? total : results.length)) {
                    temp.push(value);
                }
                return temp;
            }, []))
        }
    }, [results, total, isOpen]);

    const handleButtonClick = () => {
        setOpen(!isOpen);
    }

    return (
        <Layout className={`covr-data-section ${className}`}>
            {attrs?.title
                && <Row className="data-header">
                    <Col>
                        <h2>{attrs.title}</h2>
                    </Col>
                </Row>}
            <Row justify={`center`} className="data-body">
                <Col>
                    {(taxData) &&
                        <PostGrid
                            {...attrs}
                            data={taxData}
                        />
                    }
                </Col>
            </Row>
            {results
                && (results?.length > total)
                && <Row className={`mar-top-15`} justify="center">
                    <Button
                        className={`outlineButton thickButton width-250px`}
                        onClick={handleButtonClick}
                        type={`default`} size="large"
                    >
                        {!isOpen ? `Show More` : `Show Less`}
                    </Button>
                </Row>}
            {attrs.link?.url
                && <Row className="data-footer" justify="end">
                    <Col>
                        <a target={attrs.link?.target}
                            className="view-all" href={attrs.link?.url}>
                            {attrs.link?.title}
                        </a>
                    </Col>
                </Row>}
        </Layout>
    );
};

TaxonomyCollections.defaultProps = defaultProps;

export default TaxonomyCollections;
